export const pt = {
    //Login
    loginTitle: 'Bem-vindo',
    loginMessage: 'Faça Login para Entrar',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    newPassword: 'Nova Password',
    repeatNewPassword: 'Repete a Nova Password',
    authenticateUser: 'Verificar Utilizador',
    recoverPassword: 'Recuperar Password',
    recoverPasswordDescription: 'Verifique o seu Email e siga as Instruções para Redifinir a Password',
    forgotPassword: 'Esqueceu-se da Password',
    code: 'Código',
    acceptWordOs: 'Aceitar os',
    acceptWordAs: 'Aceitar as',
    termsConditions: 'Termos e Condições',
    cookies: 'Política de Cookies',
    privacyRule: 'Aceitar a',
    privacyRuleLink: 'confidencialidade de Dados',
    repeatPasswordLabel: 'Repita a Password Utilizada acima',
    inputLabelNewPassword: 'A Password deve Respeitar os Requisitos',
    logout: 'Terminar Sessão',
    'User Authenticated': 'Utilizador Autenticado',

    //---- Nav Bar Items-----
    inicio: 'Início',
    municipality: 'Município',
    territory: 'Território',
    autarchy: 'Autarquia',
    entity: 'Entidade',
    emissions: 'Emissões de GEE no Território',

    map: 'Mapa',
    politicas: 'Políticas',
    events: 'Eventos',
    registry: 'Cadastro',
    Energy: 'Energia',
    analytics: 'Analítica',
    timeLine: 'Análise de Dados',
    energyEmissions: 'Energia e Emissões',

    configurations: 'Configurações',

    //----- Buttons --------
    seeOnMap: 'Ver no Mapa',
    delete: 'Eliminar',
    add: 'Adicionar',
    clear: 'Limpar',
    lines: 'Linhas',
    bars: 'Barras',
    heatmap: 'HeatMap',
    report: 'Relatório',
    exportRawData: 'Exportação de Dados',
    signIn: 'Iniciar sessão',
    resetPassword: 'Redifinir Password',
    sendEmail: 'Enviar Email',
    edit: 'Editar',
    submit: 'Submeter',
    cancel: 'Cancelar',
    save: 'Guardar',
    seeDetail: 'Ver Detalhe',
    upload: 'Carregar',
    deleteDescription: 'Tem a Certeza que Pretende Apagar o Elemento?',
    search: 'Pesquisar',
    "Show Metrics": "Mostrar Metricas",
    create: 'Criar',
    //------------

    //------ Date Formats -----
    day: 'dia',
    days: 'Dias',
    week: 'Semana',
    weeks: 'Semanas',
    months: 'Meses',
    year: 'Ano',
    years: 'Anos',
    hourly: 'Por Hora',
    daily: 'Diário',
    Daily: 'Diário',
    weekly: 'Semanal',
    Weekly: 'Semanal',
    startDate: 'Data início',
    endDate: 'Data fim',
    annual: 'Anual',
    monthly: 'Mensal',
    quarter: 'Trimestral',
    yearly: 'Anualmente',
    raw: 'Bruto',
    hours: "horas",
    Hours: "Horas",

    jan: 'jan',
    feb: 'fev',
    mar: 'mar',
    apr: 'abr',
    may: 'mai',
    jun: 'jun',
    jul: 'jul',
    aug: 'ago',
    sep: 'set',
    oct: 'out',
    nov: 'nov',
    dec: 'dez',
    January: "Janeiro",
    February: "Fevereiro",
    March: "Março",
    April: "Abril",
    May: "Maio",
    June: "Junho",
    July: "Julho",
    August: "Agosto",
    September: "Setembro",
    October: "Outubro",
    November: "Novembro",
    December: "Dezembro",

    "Monday": "Segunda",
    "Tuesday": "Terça",
    "Wednesday": "Quarta",
    "Thursday": "Quinta",
    "Friday": "Sexta",
    "Saturday": "Sábado",
    "Sunday": "Domingo",

    "MON": "SEG",
    "TUE": "TER",
    "WED": "QUA",
    "THU": "QUI",
    "FRI": "SEX",
    "SAT": "SAB",
    "SUN": "DOM",

    //------------
    data: 'Dados',
    name: 'Nome',

    simple: 'Simples',
    biHourly: 'Bi-horária',
    triHourly: 'Tri-horária',
    tetraHourly: 'Tetra-horária',

    page: 'Página',
    seeMore: 'Ver Mais',
    seeLess: 'Ver Menos',
    'and others': 'e outros',

    Floor1: "1º Andar",
    Floor2: "2º Andar",
    Floor3: "3º Andar",
    Floor4: "4º Andar",
    Floor5: "5º Andar",
    Floor6: "6º Andar",
    Floor7: "7º Andar",
    Floor8: "8º Andar",
    Floor9: "9º Andar",
    Floor10: "10º Andar",

    //------------ Tooltips -----------
    passwordRequirements: 'Requisitos da Password',
    minimunCharacters: '8 caracteres mínimos',
    numberCharacter: 'Conter pelo menos 1 número',
    uppercaseLetter: 'Conter pelo menos 1 letra maiúscula',
    lowercaseLetter: 'Conter pelo menos 1 letra minúscula',
    specialCharacter: 'Conter pelo menos 1 caracter especial',
    dataBasedEReded: 'Gerado com base nos dados mais recentes da Open Data da E-REDES',
    dataRefersToYear: "Dados referentes ao ano de ",
    comparingElectricityConsumption: 'Comparando Consumos de Energia Elétrica',
    heatmapExplained: 'Heatmap gerado com base nos consumos dos Postos de Transformação de Distribuição do Território',
    heatmapTooltip: 'Heatmap apresenta a densidade do consumo elétrico no território',
    "The graph shows the average data for the last four weeks, grouped by each day of the week. Each point reflects the average of the values recorded on a given day over the last four weeks, allowing daily trends to be observed.": "O gráfico mostra a média dos dados das últimas quatro semanas, agrupados por cada dia da semana. Cada ponto reflete a média dos valores registrados em um determinado dia ao longo das últimas quatro semanas, permitindo observar tendências diárias.",
    "Percentage reflects bookings in relation to the number of seats available": "Percentagem reflete as reservas em relação ao número de lugares disponíveis",
    "Periodicity Tooltip": "Retorna as últimas 12 horas da data selecionada",
    "Drawer Weight Tooltip": "Peso da aresta, que representa a percentagem do impacto que um incidente tem sobre o nó filho",
    "Drawer Is Peer Tooltip": "Relação de paridade, indicando se a relação é entre nós do mesmo nível hierárquico ou do tipo pai-filho",
    "Drawer Invname Tooltip": "Nome do nó filho da relação",
    "Drawer Outvname Tooltip": "Nome do nó pai da relação",
    "tooltip.incident_category_description": "O campo categoria só terá valores se for selecionado primeiro um Serviço da Cidade",

    //------------ AuthContext Errors -----------
    incorrectFields: 'Username ou Password Incorreto',
    passwordNoMatch: 'As Passwords não estão iguais',
    passwordNotValid: 'Password não cumpre os requisitos',
    emailSentCode: 'Email enviado com o código de verificação',
    codeSentByMessage: 'Código mandado por mensagem',
    firstLogin: 'Pimeiro Login, precisa de verificar a conta',
    errorResetPassword: 'Algo correu mal, Por favor verifique o código ou os requisitos da password',
    infoDescription: 'Não é possiível fazer exportação sem dados',

    error: 'Erro',
    success: 'Sucesso',
    warning: 'Aviso',
    info: 'Informação',

    successAdd: 'Elemento adicionado com sucesso.',
    errorAdd: 'Erro: item não adicionado.',

    successDelete: 'Elemento apagado com sucesso.',
    errorDelete: 'Erro: item não apagado.',

    errorGettingCertificates: 'Ocorreu um erro ao tesntar obter a lista de certificados.',

    //--------------------- Filters -----------------
    filters: 'Filtros',
    rester: 'Limpar',
    savedFilters: 'Guardar filtros',
    apply: 'Aplicar',
    "All": "Todos",
    "Clear Options": "Apagar Opções",

    //--------------------- Classes -----------------
    "Buildings": "Edifícios",
    "Facilities": "Instalações",
    "Office": "Escritório",
    "Social": "Social",
    "Pavilion": "Pavilhão",
    "School": "Escola",
    "Storage": "Armazém",
    "Meeting Room": "Sala de Reuniões",
    "Expresso Corner": "Sala de Estar",
    "Level Floor": "R/Chão",
    "Bus Service": "Serviço de Autocarros",
    "Parking Service": "Serviço de Estacionamento",
    "Bus Route": "Rota de Autocarros",
    "Air Pollution Control": "Controlo da Poluição do Ar",
    "Noise Pollution Control": "Controlo da Poluição Sonora",
    "Air Quality": "Qualidade do Ar",
    "Noise": "Ruído",
    "Station": "Estação",
    "Weather Service": "Serviço Meteorológico",
    "Bus Stop": "Paragem de Autocarros",
    "Street Lighting": "Iluminação Pública",
    "Public Entity": "Entidade Pública",
    "Bus Interface": "Interface de Autocarros",
    "Road Occupation Service": "Serviço de Ocupação de Estradas",
    "Road Segment": "Segmento de Estrada",
    "Traffic Service": "Serviço de Trânsito",
    "Entry Terminal": "Terminal de Entrada",
    "Pay On Foot": "Pagamento a Pé",
    "Exit Terminal": "Terminal de Saída",
    "Manual Pay Station": "Estação de Pagamento Manual",
    "Parking Lot": "Parque de Estacionamento",
    "Parking Meter": "Parquímetro",
    "Park Barrier": "Barreira de Parque",
    "Marine Resources Control": "Controlo de Recursos Marinhos",
    "Forest Services": "Serviços Florestais",
    "Exterior Lighting": "Iluminação Exterior",
    "Storm Water Collection": "Recolha de Águas Pluviais",
    "Sanitary Waste Water Collection": "Recolha de Águas Residuais Sanitárias",
    "Water Supply": "Abastecimento de Água",
    "Civil Protection": "Proteção Civil",
    "Medical Emergency": "Emergência Médica",
    "Emergency Service": "Serviço de Emergência",
    "Fire Fighting": "Combate a Incêndios",
    "Garden": "Jardim",
    "Pavement": "Pavimento",
    "Others": "Outros",
    "Public Space": "Espaço Público",
    "Electricity Meter": "Contador de Eletricidade",
    "Off-Street Parking": "Estacionamento Privado",
    "Energy": "Energia",
    "Waste Water Collection": "Recolha de Águas Residuais",
    "Bike Sharing": "Partilha de Bicicletas",
    "Public Building Energy": "Energia de Edifícios Públicos",
    "Domestic&Recycled Waste Collection": "Recolha de Resíduos Domésticos e Reciclados",
    "Cellular Communication": "Comunicação Celular",

    //--------------------- Layers -----------------
    "Layer": "Camada",
    "City Service": "Serviço da Cidade",
    "Resource": "Recurso",
    "Supporting Service": "Serviço de Apoio",

    //--------------------- Home -----------------
    "Total Buildings": "Total de Edifícios",
    "Types of Buildings": "Tipos de Edifícios",
    "General Information of Buildings": "Informação geral de Edifícios",
    "Occupation in the Buildings": "Ocupação nos Edificíos",
    "Average Occupation": "Ocupação Média",
    "Top 5 Highest Occupancy": "Top 5 Maior Ocupação",
    "Top 5 Lowest Occupancy": "Top 5 Menor Ocupação",
    "Top 5 Highest Consumption": "Top 5 Maior Consumo",
    "Top 5 Lowest Consumption": "Top 5 Menor Consumo",
    "Garage Occupation": "Ocupação de Garagens",
    "Garage Number": "Número de Garagens",
    "Available Parking Spaces": "Lugares Disponiveis",
    "Medium Occupation": "Ocupação Média",
    "Buildings Water Consumption": "Consumo de Água dos Edifícios",
    "Current Events": "Eventos Correntes",
    "Current Incidents": "Incidentes Correntes",
    "Top 5 Events": "Top 5 Eventos",
    "Buildings Energetic Consumption": 'Consumo Energético dos Edifícios',
    "Average Consumption": "Consumo Médio",
    "Energy Consumption": "Consumo Energético",
    "Building Comfort": "Conforto do Edifício",
    "Building Occupation": "Ocupação do Edifício",
    "Capacity": "Capacidade",
    "Consumption per Floor": "Consumo por Piso",
    "Types of Access": "Tipos de Acesso",
    "Access": "Acesso",
    "Reservations": "Reservas",
    "Agreements": "Avenças",
    "Free Access": "Acesso Livre",
    "Annual Progress": "Progresso Anual",
    "filed.Unassigned Incidents": "Incidentes Não Atribuídos",
    "filed.Field Incidents": "Incidentes de Campo",
    "field.Incidents in the Last 6 Hours": "Incidentes nas Últimas 6 Horas",
    "filed.Number of Incidents By Class": "Número de Incidentes por Classe",
    "field.New incidents in the last week": "Novos Incidentes na Última Semana",
    "field.total_incidents_count": "Contagem Total de Incidentes",
    "title.Data from the last 4 weeks": "Dados Médios das Últimas 4 Semanas",
    "title.Incidents by priority": "Incidentes por Prioridade",
    "title.Cumulative Number Of Entries In The Parking": "Número Cumulativo de Entradas no Estacionamento",
    "title.Number Of Entries In The Park": "Número de Entradas no Parque",
    "title.Number Of Exits Of The Park": "Número de Saídas do Parque",
    "title.Park Total": "Parque Total",
    "title.Park Outdoor": "Parque Exterior",
    "title.Park Interior -1": "Parque Interior -1",
    "title.Park Interior -2": "Parque Interior -2",
    "title.Number Of Entries In Campus": "Número de Entradas no Campus",
    "title.Weekly Cumulative Number Of Entries Per Park": "Número Semanal Cumulativo de Entradas por Parque",
    "title.Number Of Entries In Campus By Month": "Número de Entradas no Campus por Mês",
    "title.General Consume": "Consumo Geral",
    "title.General Lighting Consumption of the Campus": "Consumo Geral de Iluminação do Campus",
    "title.Weekly Consumption By Building": "Consumo Semanal por Edifício",
    "title.Consumption on the Previous Day": "Consumo no Dia Anterior",
    "title.Energy Consumption": "Consumo Energético",
    "title.Irrigation Efficiency": "Eficiência de Rega",
    "title.Water Consumption Of MINA & EPAL": "Consumo de Água da MINA & EPAL",
    "title.Irrigation Water Consumption": "Consumo de Água de Rega",
    "title.MINA & EPAL Consumption": "Consumo da MINA & EPAL",
    "title.EPAL Flow Rate": "Caudal EPAL",
    "title.MINA Flow Rate": "Caudal MINA",
    "title.Buildings Consumption": "Consumo dos Edifícios",
    "title.Water Consumption": "Consumo de Água",
    "title.Temperature": "Temperatura",
    "title.CO₂ Emissions": "Emissões de CO₂",
    "title.Air Humidity": "Humidade do Ar",
    "title.Average Sound Level": "Nível Sonoro Médio",
    "title.Soil Temperature": "Temperatura do Solo",
    "title.Soil Electrical Conductivity": "Condutividade Elétrica do Solo",
    "title.Soil Humidity": "Humidade do Solo",
    "title.Atmospheric Data": "Dados Atmosféricos",
    "title.Noise": "Ruído",
    "title.Soil": "Solo",
    "title.Data from Sunday to Saturday": "Dados de Domingo a Sábado",
    "Water": "Água",
    "Green Spaces": "Espaços Verdes",
    "Environment": "Ambiente",

    // ---------------- Services Map Widgets -------
    "title.services_map_widgets_top5_pm_2_5": "Top 5 Níveis de PM2.5",
    "title.services_map_widgets_evolution_6h_pm_2_5": "Evolução de PM2.5 nas últimas 6h",
    "title.services_map_widgets_top5_noise": "Top 5 Níveis de Db",
    "title.services_map_widgets_evolution_6h_noise": "Evolução de Db nas últimas 6h",
    "title.services_map_widgets_top5_routes": "Top 5 Rotas com Maior Atraso",
    "title.services_map_widgets_dual_evolution_6h_routes": "Tempo Máximo de Atraso nas últimas 6h",
    "title.delay": "Atraso",
    "title.advancement": "Antecipação",

    //--------------------- Mapa -----------------
    "Events Number": "Número de Eventos",
    "Incidents Number": "Número de Incidentes",
    "Incidents": "Incidentes",
    "Incident": "Incidente",
    "Services": "Serviços",
    "Low": "Baixo",
    "Medium Low": "Médio Baixo",
    "Medium": "Médio",
    "Medium High": "Médio Alto",
    "High": "Alto",
    "5 - Low": "Baixo",
    "4 - Medium Low": "Médio Baixo",
    "3 - Medium": "Médio",
    "2 - Medium High": "Médio Alto",
    "1 - High": "Alto",
    "Incidents by Level": "Incidentes por Prioridade",
    "Field Incidents": "Field Incidents",
    "Unassigned Incidents": "Incidentes Não Atribuidos",
    "Select Services with Incidents": "Selecione Serviços com Incidentes",
    "Select Services": "Selecione Serviços",
    'Select classes': 'Selecione Classes',
    "Select Priorities": "Selecione Prioridades",
    "Select Severities": "Selecione Severidades",
    "View Map": "Ver Mapa",
    "Quick Access": "Acessos Rápidos",
    "Consumption By User": "Consumo por utilizador",
    "Building Consumption": "Consumo do edifício",
    "Back": "Voltar",
    "Incidents": "Incidentes",
    "button.create_incident": "Criar Incidente",
    "action.create_incident": "Criar Incidente",
    "button.Create Geometry": "Ver Geometria",
    "notification.without polygon coordinates": "Sem coordenadas de polígono",
    "title.services_map_widgets_top5_Energy Consumption": "Top 5 Consumo Energético",
    "title.services_map_widgets_evolution_6h_Energy Consumption": "Evolução do Consumo Energético nas últimas 6h",

    //--------------------- Assets -----------------
    "Assets": "Ativos",

    //--------------------- OBJ Translations -----------------
    "Available Rooms": "Salas disponíveis",
    "Occupied Rooms": "Salas ocupadas",

    //--------------------- Item Details -------
    "View": "Visão",
    "Overview": "Visão Geral",
    "Room Detail": "Detalhes da Sala",
    "Comfort": "Conforto",
    "Parking": "Estacionamento",
    "button.daily_analysis": "Análise Diária",
    "button.historic": "Histórico",
    "button.buildings_detail": "Detalhe de Edifício",
    "Digital Twin": "Digital Twin",
    "Energetic Consumption": "Consumo Energético",
    "Average Energy Consumption": "Consumo Energético Médio",
    "Energy consumption per user": "Consumo Energético por Utilizador",
    "Evolution of floor energy consumption": "Evolução do Consumo de Energia Piso",
    "Consumption per Hour": "Consumo por hora",
    "Energy Consumption per user": "Consumo energético por utilizador",
    "Building Energy Consumption Evolution": "Evolução do Consumo de Energia no Edifício",
    "Peak of the month": "Pico do mês",
    "Evolution of floor energy consumption during the day": "Evolução do Consumo de Energia Piso durante o dia",
    "Lighting": "Luminosidade",
    "Temperature": "Temperatura",
    "Humidity": "Humidade",
    "Air Quality": "Qualidade do Ar",
    "Noise": "Ruído",
    "Luminosity": "Luminosidade",
    "Building": "Edifício",
    "Floor": "Piso",
    "Room Details": "Detalhes de Salas",
    "Vacant Rooms": "Salas Vagas",
    "Vacant": "Vagas",
    "Check-In and Room Reservation": "Check-In e Reserva de Salas",
    "Room Occupation": "Ocupação de Salas",
    "Average Value": "Valor Médio",
    "Average Ideal Temperature": "Temperatura Ideal Média",
    "Ideal Value": "Valor Ideal",
    "Temperature Variation": "Variação de Temperatura",
    "Humidity Variation": "Variação de Humidade",
    "Air Quality Variation": "Variação da Qualidade do Ar",
    "Lighting Variation": "Variação da Luminosidade",
    "Noise Variation": "Variação de Ruído",
    "Average Reservations Made": "Média de Reservas Realizadas",
    "Average Check-ins Made": "Média de Check-ins Realizados",
    "Average Missing Checkout": "Média de Check-out Em Falta",
    "Rooms Reservations": "Reserva de Salas",
    "Rooms Check-in Carried Out": "Check-ins de Salas Realizados",
    "Seats Reservation": "Reserva de Lugares",
    "Map Occupation": "Mapa de Ocupação",
    "Average Use Of Rooms": "Utilização Média de Salas",
    "Total Reservations": "Total de Reservas",
    "Occupation Map": "Mapa de Ocupação",
    "Check-ins Done": "Check-ins Realizados",
    "Check-outs Missing": "Check-outs em Falta",
    "Real Occupation": "Ocupação Real",
    "Distribution of people by floor": "Distribuição de pessoas por piso",
    "Distribution throughout the day": "Distribuição ao longo do dia",
    "Room Reservation": "Reserva de Salas",
    "Check-ins Ongoing": "Check-ins Correntes",
    "button.cpe_details": "Detalhe por CPE",
    "Top Energy": "Pico de Potência Ativa",
    "Inductive Consumption": "Consumo de Energia Indutiva",
    "Energy Produced": "Energia produzida",
    "Active Consumption": "Consumo de Energia Ativa",
    "Capacitive Consumption": "Consumo de Energia Capacitiva",
    "Grid Injection": "Injeção na rede",
    "Load Diagram": "Diagrama de Carga",
    "Highest Registered Peak": "Pico Máximo Registado",
    "Daily Power Peak": "Picos de Carga Diários",
    "Production Peak": "Picos de Produção",
    "Accumulated Emissions Avoided": "Emissões Equivalentes Evitadas",
    "Information From Previous Period": "Informação dos 31 dias anteriores",
    "Energy vs Production": "Energia vs Produção",
    "Active Power and Production Power": "Potência Ative e Potência de Produção",
    "Inductive Power and Capacitive Power": "Potência Reativa Indutiva e Capacitiva",
    "Metric occupation": "Ocupação: ",
    "Metric temperature": "Temperatura: ",
    "Seats Taken": "Lugares Ocupados",
    "Reserved Seats": "Lugares Reservados",
    "Average Length of Stay": "Tempo Médio de Permanência",
    "Seat Availability": "Disponibilidade de Lugares",
    "Total Number of Vehicles Throughout the Day": "Número total de veículos ao longo do dia",
    "Occupation by Payment Type": "Ocupação por tipo de pagamento",
    "Occupation by type of place": "Ocupação por tipo de lugares",
    "Active Energy": "Energia Activa",
    "Active Energy Consumption": "Consumo de Energia Ativa",
    "Inductive Energy Consumption": "Consumo de Energia Indutiva",
    "Capacitive Energy Consumption": "Consumo de Energia Capacitiva",
    "Maximum Consumption": "Consumo Máximo",
    "Average Consumption days of the week": "Consumo Médio Dias da Semana",
    "Load Diagrams": "Diagramas de Carga",
    "Export": "Exportar",
    "It is not possible to export data for annual period": "Não é Possível Exportar Dados para um Período Anual.",
    "Exportation for the selected period ": "Exportação para o Período Filtrado de ",
    "Cost Estimation": "Estimação de Custos",
    "Gas Consumption": "Consumo de Gás",
    "Associated GEE Emissions": "Emissões GEE Associadas",
    "Energetic Certification": "Certificação Energética",
    "Days of the week": "Dias da Semana",
    "Pick Power": "Pico de Potência",
    "Average Power": "Potência Média",
    "Saturdays and Sundays": "Sábados e Domingos",
    "Consumption": "Consumos",
    "Four-Hourly": "Tetra-horário",
    "Empty": "Vazio",
    "Full": "Cheio",
    "Edge": "Ponta",
    "Super Empty": "Super Vazio",
    "Provided by the grid": "Fornecida pela Rede",
    "Injected into the grid": "Injetada na Rede",
    "Fixed Tariff Term": "Termo Tarifário Fixo",
    "Contracted Power": "Potência Contratada",
    "Power at Peak Hours": "Potência em Horas de Ponta",
    "Inductive Energy": "Energia Indutiva",
    "Capacitive Energy": "Energia Capacitiva",
    "Simple": "Simples",
    "Bi-hourly": "Bi-horária",
    "Tri-hourly": "Tri-horária",
    "Tetra-hourly": "Tetra-horária",
    "Related Assets": "Ativos Relacionados",
    "Inductive": "Indutiva",
    "Capacitive": "Capacitiva",
    "Reactive Energy": "Energia Reativa",
    "Power Changes": "Encargos de Potência",
    "Peak Hours": "Horas de Ponta",
    "Incident List": "Lista de Incidentes",
    "Top 5 Incidents": "Top 5 Incidentes",
    "Heatmap": "Mapa de Calor",
    "button.cpe_historic": "Historico de CPE",
    "Reservations": "Reservas",
    "Extended Reservations": "Reservas",
    "Real Occupation": "Ocup. Real",
    "Check-in": "Check-in",
    "Occupation": "Ocupação",
    "Reserved Rooms": "Salas reservadas",
    "Week Variation": "Variação Semanal",
    "Free": "Livre",
    "Occupied": "Ocupado",
    "Sound Level": "Nível de Som",
    "Light Intensity": "Intensidade de Luz",
    "Than": "Que",
    "Booked": "Reservadas",
    "Invalid POI position": "Posição do POI inválida",
    "Reactive Inductive Energy": "Energia Reativa Indutiva",
    "Reactive Capacitive Energy": "Energia Reativa Capacitiva",
    "Active Power": "Potência Ativa",
    "Reactive Inductive Power": "Potência Reativa Indutiva",
    "Reactive Capacitive Power": "Potência Reativa Capacitiva",
    "Production Power": "Potência de Produção",
    "Reserved": "Reservado",
    "Inductive Reactive Energy": "Energia Reactiva Indutiva",
    "Capacitive Reactive Energy": "Energia Reactiva Capacitiva",
    "Average Total": "Média Total",
    "Non-Weekend": "Fora de Fim de Semana",
    "Weekend": "Fim de Semana",
    "Reactive Power": "Potência Reativa",
    "Inductive Power": "Potência Indutiva",
    "Alerts": "Alertas",
    "Details": "Detalhes",
    "Indoor Air Quality": "Qualidade do Ar Interior",
    "input.Indicators": "Indicadores",
    "input.No_Data": "Sem Dados",
    "button.Occupation_Layer": "Layer de Ocupação",
    "button.Humidity_Layer": "Layer de Humidade",
    "button.Temperature_Layer": "Layer de Temperatura",
    "button.Air_Quality_Layer": "Layer de Qualidade do Ar",
    "button.Lighting_Layer": "Layer de Luminosidade",
    "button.Noise_Layer": "Layer de Ruído",
    "button.Incidents_Layer": "Layer de Incidentes",
    "button.digital_twin": "Digital Twin",
    "button.Services_Layer": "Layer de Serviços",
    "button.IVP_Layer": "IVP Layer",
    "button.OVP_Layer": "OVP Layer",
    "message.Last_12_Hours": "Últimas 12 horas",
    "button.details": "Detalhes",
    "button.incidents": "Incidentes",
    "More Details": "Mais Detalhes",
    "title.By Status": "Por Estado",
    "New": "Novo",
    "Registered": "Registado",
    "In Progress": "Em Progresso",
    "Resolved": "Resolvido",
    "Closed": "Fechado",
    "message.by category": "Por Categoria",
    "title.Evolution of weather in the last 24h": "Evolução do Tempo nas Últimas 24h",
    "title.Temperature evolution - last 7 days": "Evolução da Temperatura - Últimos 7 dias",

    //--------------------- EVENTS -------
    "Events Severity": "Eventos por Gravidade",
    "Critical": "Crítico",
    "Others": "Outros",
    "Events Map": "Mapa de Eventos",
    "Event Density": "Densidade de Eventos",
    "message.by_severity": "Por Gravidade",

    //--------------------- Configurations -------
    "Configurations": "Configurações",
    "Users List": "Lista de Utilizadores",
    "Add User": "Adicionar Utilizador",
    "Add": "Adicionar",
    "Edit": "Editar",
    "Estimated Value": "Valor Estimado",
    "Real Value": "Valor Real",
    "Average Consumption for Homologated Period": "Consumo Médio Periodo Homologo",
    "Active raw power": "Potência activa raw",
    "Maximum power allowed": "Potência Máxima Admissível",
    "Employees": "Colaboradores",
    "Clients": "Clientes",
    "Visitors": "Visitantes",
    "Contracts": "Avenças",
    "than": "que",
    "(liters)": "(litros)",

    "Estimated Value": "Valor Estimado",
    "Real Value": "Valor Real",
    "Average Consumption for Homologated Period": "Consumo Médio Periodo Homologo",
    "Active raw power": "Potência activa raw",
    "Maximum power allowed": "Potência Máxima Admissível",
    "Employees": "Colaboradores",
    "Clients": "Clientes",
    "Visitors": "Visitantes",
    "Widget List": "Lista de Widgets",
    "Add Widget": "Adicionar Widget",
    "Phone Number": "Número de Telefone",
    "Zones": "Zonas",
    "Tags": "Etiquetas",

    "day": "dia",
    "dia": "day",
    "ano": "year",
    "month": "mês",
    "mes": "month",
    "mês": "month",
    "hora": "hour",
    "hour": "hora",

    "button.metric_labels_configuration": "Configuração de Etiquetas de Métricas",
    "button.system_label_mapping_configuration": "Configuração do Mapeamento de Etiquetas do Sistema",
    "Advanced Metrics": "Métricas Avançadas",

    "Tenant": "Inquilino",
    "Class": "Classe",
    "Source Table": "Tabela de Origem",

    "Source Metric Label": "Fonte Rótulo da Métrica",
    "Operations": "Operações",
    "Operation Horizon": "Horizonte da Operação",
    "Expression": "Expressão",
    "Destination Metric Label": "Etiqueta Métrica de Destino",
    "Destination Metric Label Unit": "Unidade de Etiqueta Métrica de Destino",
    "Metric Label": "Etiqueta métrica",
    "Is Standard": "É padrão",
    "Unit Code": "Código da unidade",
    "Type": "Tipo",
    "Conversion": "Conversão",
    "Offset": "Desvio",
    "Power": "Potência",
    "Slope": "Inclinação",
    "Standard Unit": "Unidade Padrão",
    "Entity": "Entidade",
    "Entity Label": "Etiqueta da Entidade",
    "Entity Unit": "Unidade da Entidade",
    "System Label": "Etiqueta do Sistema",
    "System Unit": "Unidade do Sistema",
    "Metric List": "Lista de Métricas",
    "Metric Label List": "Lista de Etiquetas de Métricas",
    "System Label Mapping List": "Lista de Mapeamento de Etiquetas do Sistema",
    "Add Metric": "Adicionar Métrica",
    "Add Metric Label": "Adicionar Etiquetas de Métricas",
    "Add System Label": "Adicionar Etiqueta do Sistema",

    "Detail By Name": "Detalhe pelo Nome",
    "Type Number": "Número de Tipos",
    "Class Number": "Número de Classes",
    "Detail Number": "Número de Detalhes",
    "Invalid cron format.": "Cron com formato invalido.",
    "Invalid Date": "Data Invalida",

    "Widget Type": "Tipo de Widget",
    "Scheduler": "Agendador",
    "Registry": "Registro",
    "Start Time": "Data/Hora de Início",
    "End Time": "Data/Hora de Término",
    "Metric": "Métrica",
    "Source Periodicity": "Periodicidade da Fonte",
    "History": "Historia",
    "Data Aggregation": "Agregação de Informação",
    "Transformation": "Transformação",
    "Widget Dataset Name": "Nome do Conjunto de Dados do Widget",
    "Privacy": "Privacidade",
    "Description": "Descrição",
    "Select Value": "Selecionar Valor",
    "Insert Value": "Inserir Valor",
    "Insert Values": "Inserir Valores",
    "Input Text": "Inserir Texto",
    "Select Items": "Selecionar Items",
    "Select Date": "Selecionar Data",
    "Absolute": "Absoluto",
    "Relative": "Relativo",
    "Last": "Último",
    "Enter number and (day or hour)": "Digite o Número e (dia ou hora)",
    "Enter number and (day, month or year)": "Digite o Número e (dia, mês ou ano)",

    "Indicates the source of the data, which will be used to do any operation.": "Indica a fonte dos dados, que será utilizada para efetuar qualquer operação.",
    "Selection of all federated classes, i.e., all classes that are currently capable of receiving data. If any node is federated, it will be capable of receiving data.": "Seleção de todas as classes federadas, ou seja, todas as classes que estão atualmente aptas a receber dados. Se algum nó for federado, será capaz de receber dados.",
    "Selection of all possible data tables, i.e., all tables that <tenant>  has access, that stores or will store data.": "Seleção de todas as tabelas de dados possíveis, ou seja, todas as tabelas a que <tenant> tem acesso, que armazenam ou irão armazenar dados.",
    "Selection of all possible metrics, i.e., all metrics that <tenant>  has access. Note: It\'s possible to not have data for this metric, if the metric is only added and the data is not sent.": "Seleção de todas as métricas possíveis, ou seja, todas as métricas a que <tenant> tem acesso. Nota: É possível não ter dados para esta métrica, se a métrica for apenas adicionada e os dados não forem enviados.",
    "This dropdown menu allows the selection of a specific data periodicity: hourly, daily, or monthly, i.e. the data will be aggregated by the specified period.": "Este menu pendente permite a seleção de uma periodicidade de dados específica: horária, diária ou mensal, ou seja, os dados serão agregados pelo período especificado.",
    "These fields together indicates the transformation to apply to the data (Operation + Expression) and the frequency of the data processment (Operation Horizon)": "O conjunto destes campos indica a transformação a aplicar aos dados (Operação + Expressão) e a frequência do processamento de dados (Operação Horizonte)",
    "These fields together indicates the transformation to apply to the data (Operation + Expression) and the frequency of the data processment (Operation Horizon)": "Estes campos, em conjunto, indicam a transformação a aplicar aos dados (Operação + Expressão) e a frequência do processamento de dados (Horizonte de Operação)",
    "Math Expression with the available functions": "Expressão matemática com as funções disponíveis",
    "Example of valid Expression: x+2": "Exemplo de expressão válida: x+2",
    "Indicates the output label of the processed metric.": "Indica a etiqueta de saída da métrica processada.",
    "Indicates the output unit of the processed metric.": "Indica a unidade de saída da métrica processada.",

    "Expression does not contain x variable.": "A expressão não contém a variável x.",
    "Success! With": "Sucesso! Com",
    "the result was:": "o resultado foi: ",
    "Error in Expression.": "Erro na Expressão.",

    "Indicates the  the section of the infrastructure that will be used to create the widget.": "Indica a secção da infraestrutura que será utilizada para criar o widget.",
    "Indicates the type of widget that will be generated. Each processes data in a unique way.": "Indica o tipo de widget que será gerado. Cada um processa os dados de uma forma única",
    "String representing a cron expression. Syntax: \"minutes hours day-of-month month day-of-week year\" This will generate a schedule to update the widget according to the specified expression (in UTC).": "Cadeia de caracteres que representa uma expressão cron. Sintaxe: \"minutos horas dia do mês mês dia da semana ano\". Isto irá gerar um calendário para atualizar o widget de acordo com a expressão especificada (em UTC).",
    "Represents the type of infrastructure available, such as Buildings or Infrastructure.": "Representa o tipo de infraestrutura disponível, como Edifícios ou Infra-estruturas.",
    "Represents the classes available for the selected type. For example, for \"Buildings\", the classes could include Administrative or Cultural Spaces.": "Representa as classes disponíveis para o tipo selecionado. Por exemplo, para \“Edifícios\”, as classes podem incluir Espaços Administrativos ou Espaços Culturais.",
    "Indicates if the result will contain detailed information about each data node separately. If set to True, details for each data node will be shown individually.": "Indica se o resultado conterá informações detalhadas sobre cada nó de dados separadamente. Se definido como True, os detalhes de cada nó de dados serão mostrados individualmente.",
    "Input for start time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Entrada para a hora de início através de um calendário ou removendo para a data atual. Palavras-chave relativas:(dia/hora) Últimas palavras-chave:(dia/mês/ano)",
    "Input for end time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Introduza a hora de fim através de um calendário ou removendo para a data atual. Palavras-chave relativas:(dia/hora) Últimas palavras-chave:(dia/mês/ano)",

    "Indicates the  the section of the infrastructure that will be used to create the widget.": "Indica a secção da infraestrutura que será utilizada para criar o widget.",
    "Indicates the type of widget that will be generated. Each processes data in a unique way.": "Indica o tipo de widget que será gerado. Cada um processa os dados de uma forma única.",
    "String representing a cron expression. Syntax: \"minutes hours day-of-month month day-of-week year\" This will generate a schedule to update the widget according to the specified expression (in UTC).": "Cadeia de caracteres que representa uma expressão cron. Sintaxe: \“minutes hours day-of-month month day-of-week year\” Isso gerará um cronograma para atualizar o widget de acordo com a expressão especificada (em UTC).",
    "This dropdown menu allows the selection of a specific data periodicity: hourly, daily, or monthly. This means the working data will be the data aggregated in the specified period.": "Este menu pendente permite a seleção de uma periodicidade de dados específica: horária, diária ou mensal. Isto significa que os dados de trabalho serão os dados agregados no período especificado.",
    "Shows all the metrics avaible to construct the data set.": "Mostra todas as métricas disponíveis para construir o conjunto de dados.",
    "Input for start time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Entrada para a hora de início através de um calendário ou removendo para a data atual. Palavras-chave relativas: (dia/hora) Últimas palavras-chave: (dia/mês/ano)",
    "Input for end time either by a calendar or by removing to the current date. Relative Keywords:(day/hour) Last Keywords:(day/month/year)": "Introduza a hora de fim através de um calendário ou removendo para a data atual. Palavras-chave relativas:(dia/hora) Últimas palavras-chave:(dia/mês/ano)",
    "The first field indicates which transformation to apply to the result from the available options. The second field is a valid mathematical expression that will be applied to the result after the transformation.": "O primeiro campo indica qual a transformação a aplicar ao resultado, de entre as opções disponíveis. O segundo campo é uma expressão matemática válida que será aplicada ao resultado após a transformação.",
    "Represents the type of infrastructure available, such as Buildings or Infrastructure.": "Representa o tipo de infraestrutura disponível, como Edifícios ou Infra-estruturas.",
    "Represents the classes available for the selected type. For example, for \"Buildings\", the classes could include Administrative or Cultural Spaces.": "Representa as classes disponíveis para o tipo selecionado. Por exemplo, para \“Edifícios\”, as classes podem incluir Espaços Administrativos ou Espaços Culturais.",
    "Indicates if the result will contain detailed information about each data node separately. If set to True, details for each data node will be shown individually.": "Indica se o resultado conterá informações detalhadas sobre cada nó de dados separadamente. Se definido como Verdadeiro, os detalhes de cada nó de dados serão mostrados individualmente.",
    "The field box represents the top N from the Type category.": "A caixa de campo representa os N melhores da categoria Tipo.",
    "The second box represents the top N from the Class category.": "A segunda caixa representa os N de topo da categoria Classe.",
    "The third box represents the top N from the Name category.": "A terceira caixa representa os N mais importantes da categoria Nome.",
    "This field indicates whether the result of the widget will include historical data. If set to True, the datasets will vary according to the specified time period.": "Este campo indica se o resultado do widget incluirá dados históricos. Se definido como Verdadeiro, os conjuntos de dados variarão de acordo com o período de tempo especificado.",
    "This setup indicates how to divide the dataset according to the specified period. These selections do not affect the transformation input. The first field represents a quantifying number, and the second field specifies whether that number is in hours, days, or months.": "Esta configuração indica como dividir o conjunto de dados de acordo com o período especificado. Estas selecções não afectam a entrada de transformação. O primeiro campo representa um número quantificador e o segundo campo especifica se esse número é em horas, dias ou meses.",
    "An identified name for the widget": "Um nome identificado para o widget",
    "Public or Private": "Público ou Privado",
    "A Description for the widget": "Uma Descrição para o widget",
    "Threshold List": "Lista de Thresholds",
    "Add Threshold": "Adicionar Threshold",
    "1. Choose Affected Resource": "1. Escolher Recurso Afetado",
    "2. Create Threshold": "2. Criar Threshold",
    "Apply": "Aplicar",
    "Close": "Fechar",
    "Next": "Seguinte",
    "Item Name": "Nome do Item",
    "Urgency": "Urgencia",
    "Open Threshold": "Limite Aberto",
    "Close Threshold": "Limite Fechado",
    "Generate Incident": "Gerar Incidente",
    "Event Description": "Descrição do Evento",
    "Is Default": "Predefinido",
    "message.services_not_found": "O recurso não tem serviços correspondentes, pelo que não é possível criar um incidente",
    "notification.success_add_threshold": "Threshold adicionado com sucesso",
    "notification.error_add_threshold": "Erro ao adicionar threshold",
    "notification.success_edit_threshold": "Threshold editado com sucesso",
    "notification.error_edit_threshold": "Erro ao editar threshold",
    "notification.success_remove_threshold": "Threshold removido com sucesso",
    "notification.error_remove_threshold": "Erro ao remover threshold",
    "message.generate_service_not_editable": "Em modo de edição, não é possível alterar este campo",
    "button.select_metric_labels": "Selecionar Etiquetas de Métricas",
    "button.metrics_configurations": "Configurações de Métricas",
    "Period": "Período",
    "input.city_service": "Serviço da Cidade",
    "input.impact": "Impacto",
    "input.latitude": "Latitude",
    "input.longitude": "Longitude",
    "input.description": "Descrição",
    "input.title": "Título",
    "input.urgency": "Urgência",
    "notification.success_create_incident": "Incidente criado com sucesso",
    "notification.error_create_incident": "Erro ao criar incidente",
    "input.incident_number": "Número de Incidente",
    "input.service_class": "Classe de Serviço",
    "input.location": "Localização",
    "input.last_update": "Última Atualização",
    "input.name": "Nome",
    "input.status": "Estado",
    "input.priority": "Prioridade",
    "input.open_date": "Data de Abertura",
    "input.category": "Categoria",
    "input.class": "Classe",
    "input.address": "Morada",
    "input.severity": "Severidade",
    "input.type": "Tipo",
    "input.installation_point": "Ponto de Instalação",
    "input.source": "Fonte",
    "input.family": "Família",
    "title.top5_level_pm2_5": "Top 5 Níveis de PM2.5",
    "title.pm2_5_week_evolution": "Evolução de PM2.5 - dias da semana",
    "title.pm2_5_year_evolution": "Evolução Anual de PM2.5",
    "title.top5_level_db": "Top 5 Níveis de Ruído",
    "title.db_week_evolution": "Evolução de Ruído - dias da semana",
    "title.db_year_evolution": "Níveis de ruído de {{lastYear}} e {{actualYear}}",
    "title.average": "Média",
    "title.max": "Máximo",
    "title.Top 5 routes with Longest delay": "Top 5 rotas com maior atraso",
    "title.Progress and delays - days of the week": "Progresso e Atrasos - dias da semana",
    "title.Annual progress and delays 2025": "Progresso e Atrasos Anuais {{actualYear}}",
    "title.Top worst services MRT": "Top piores serviços TMR",
    "title.Top worst incidents MRT": "Top piores incidentes TMR",
    "title.Field Incidents": "Incidentes de Field",
    "title.Unassigned Incidents": "Incidentes Não Atribuídos",
    "title.High & Medium High Incidents": "Incidentes Alto e Médio Alto",
    "title.Max Resolution Time": "Tempo Máximo de Resolução",
    "title.Evolution of PM2.5 Levels on the last 12h": "Evolução dos Níveis de PM2.5 nas últimas 12h",
    "title.Air Density across the territory - last 7 days": "Densidade do Ar pelo Território - últimos 7 dias",
    "title.Evolution of Db’s Levels on the last 12h": "Evolução dos Níveis de Db nas últimas 12h",
    "title.Noise Density across the territory - last 7 days": "Densidade de Ruído pelo Território - últimos 7 dias",

    //--------------------- Digital Twin -------
    "Without coordinates": "Sem coordenadas",
    "Level 1": "Nível 1",
    "Level 2": "Nível 2",
    "Level 3": "Nível 3",

    //--------------------- Digital Twin Metrics -------
    "Metrics": "Métricas",
    "Periodicity": "Periodicidade",
    "Date": "Data",

    //--------------------- Digital Twin Drawer -------
    //Incident Drawer
    "Reference Number": "Número de Referência",
    "Priority": "Prioridade",
    "Category": "Categoria",
    "Service Class": "Classe de Serviço",
    "Open Date": "Data de Abertura",
    "Status": "Estado",
    //Node Drawer
    "Name": "Nome",
    "Class": "Classe",
    "Family": "Família",
    "Type": "Tipo",
    "Label": "Etiqueta",
    "Layer": "Camada",
    //Edge Drawer
    "Weight": "Peso",
    "Is Peer": "Relação Par a Par",
    "Invname": "Nó Filho",
    "Outvname": "Nó Pai",

    //--------------------- Items Configuration -------
    "Items List": "Lista de Itens",
    "Item Details": "Detalhes do Item",
    "Mandatory Properties": "Propriedades Obrigatórias",
    "Optional Properties": "Propriedades Opcionais",
    "Create Item Tenant Description": "Ao selecionar um tenant, o campo family é preenchido automaticamente com as familis disponíveis para o tenant selecionado",
    "Create Item Family Description": "Ao selecionar uma family, o campo class é preenchido automaticamente com as classes disponíveis para a family selecionada",
    "Create Item Class Description": "Ao selecionar uma class, novas propriedades obrigatórias e opcionais aparecem de acordo com a classe selecionada",
    "Relations of": "Relações de",
    "Create Item Success": "O item foi criado com sucesso",
    "Create Item Error": "Ocorreu um erro ao criar o item",
    "Edit Item Success": "O item foi editado com sucesso",
    "Edit Item Error": "Ocorreu um erro ao editar o item",
    "Remove Item Success": "O item foi removido com sucesso",
    "Remove Item Error": "Ocorreu um erro ao remover o item",
    "Node already exists!": "O item já existe com o mesmo nome",
    "Edit Item": "Editar Item",
    "Delete Item": "Eliminar Item",
    "Item Relations": "Relações do Item",
    "Create Item Federation Description": "Se o campo for preenchido, será criada uma federação como entidade externa",

    //--------------------- Relations Configuration -------
    "Create Relation Success": "A relação foi criada com sucesso",
    "Create Relation Error": "Ocorreu um erro ao criar a relação",
    "Remove Relation Success": "A relação foi removida com sucesso",
    "Remove Relation Error": "Ocorreu um erro ao remover a relação",
    "The item does not exist in the parent field": "O item não existe no campo pai",
    "The item does not exist in the child field": "O item não existe no campo filho",
    "Parent and child are the same node": "O pai e o filho são o mesmo item",
    "Relationship already exists between parent and child": "A relação já existe entre o pai e o filho",
    "Parent Item": "Item Pai",
    "Child Item": "Item Filho",
    "Relation": "Relação",
};